// import Cookies from 'js-cookie';

const layoutCommon = {
  state: {
    shrink: false,
  },
  mutations: {
    setShrink(state, val) {
      // console.log("setShrink", val);
      state.shrink = val
      // sessionStorage.user = JSON.stringify(user);
    },
  },
}

export default layoutCommon
